import { postJson } from '#/utils/http/postJson';

export async function userDashboardApiCreateSavedListing(
  id: string,
  type: string,
) {
  return postJson(`/data/saved-listings`, { id, type });
}
